import {
  RESET_STATE,
  FETCH_LOGIN_DETAILS,
  SEND_OTP,
  PASSWORD_RESET,
  PASSWORD_RESET_FLAG,
  GET_HISTORY,
  RESEND_OTP,
  SEND_OTP_LOGIN
} from './actionConstants'

export const resetState = () => {
  return {
    type: RESET_STATE,
  }
}

export const fetchLoginDetails = (data) => {
  return {
    type: FETCH_LOGIN_DETAILS,
    payload: data
  }
}

export const sendOTPForgotPass = (data) => {
  return {
    type: SEND_OTP,
    payload: data
  }
}

export const sendOTP = (data) => {
  return {
    type: SEND_OTP_LOGIN,
    payload: data
  }
}

export const passwordReset = (data) => {
  return {
    type: PASSWORD_RESET,
    payload: data
  }
}

export const passwordResetFlag = (bool) => {
  return {
    type: PASSWORD_RESET_FLAG,
    flag: bool
  }
}

export const resendOTP = (data) => {
  return {
    type: RESEND_OTP,
    payload: data
  }
}

export const getHistory = (obj) => {
  return {
    type: GET_HISTORY,
    obj
  }
}



// WEBPACK FOOTER //
// ./src/actions/AppActions.js